import script from "./OrganizerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizerPage.vue?vue&type=script&setup=true&lang=js"

import "./OrganizerPage.vue?vue&type=style&index=0&id=3a62522e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a62522e"]])

export default __exports__